const comments = [
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20in%20casual%20style%2C%20warm%20friendly%20smile%2C%20simple%20light%20background%2C%20natural%20daylight%2C%20clean%20professional%20headshot%2C%20soft%20bokeh&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    text: '窝窝影院真的是我追剧这么久以来体验最好的平台了！画质超清而且完全不卡，最关键的是真的没有广告，一口气看完一部剧的感觉太爽了！强烈推荐！',
    time: '2 天前',
  },
  {
    name: '剧荒终结者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20expression%2C%20casual%20modern%20style%2C%20simple%20clean%20background%2C%20natural%20lighting%2C%20professional%20headshot%2C%20warm%20tones&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    text: '之前总是找不到好看的剧，朋友推荐了窝窝影院之后简直打开了新世界！更新速度超级快，韩剧几乎同步播出，排行榜推荐也很靠谱，拯救了我无数个无聊的夜晚。',
    time: '5 天前',
  },
  {
    name: '深夜观影人',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20with%20glasses%2C%20warm%20smile%2C%20cozy%20indoor%20lighting%2C%20simple%20background%2C%20professional%20headshot%20style%2C%20natural%20look%2C%20soft%20warm%20colors&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    text: '作为一个悬疑剧重度爱好者，窝窝影院的分类做得太细致了，各种冷门悬疑剧都能找到。而且评论区氛围也很好，大家都认真在讨论剧情，不像其他平台全是刷屏广告。',
    time: '1 周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">用户热评</h2>
          <p className="mt-2 text-sm text-foreground-500">听听追剧同好们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.map((item) => (
            <div key={item.name} className="bg-background-100 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-300 flex-shrink-0">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground-900">{item.name}</h3>
                  <p className="text-xs text-foreground-400">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              <div className="flex items-center gap-1 mt-4 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}